import { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom'

import Navbar from '../components/navbar_poc'
import Shape from '../components/shape'
import ShapeTwo from '../components/shape-two'
import Footer from '../components/footer';
import SEO from '../components/seo'
import bg from '../assets/images/bg.jpg'
import heroImg from '../assets/images/B2BBookCoverv4.jpg'

import { contactData,footerBlogSocial } from '../data'

import Modal from 'react-bootstrap/Modal';
import emailjs from '@emailjs/browser';
import axios from 'axios'
export default function Bridge() {
  const [show, setShow] = useState(false);
  const form = useRef();
  const navigate = useNavigate();
  const sendEmail = async (e) => {
    e.preventDefault(); // prevent page reload

    const formData = new FormData(form.current);

    const data = {
      firstName: formData.get('firstName'),
      lastName: formData.get('lastName'),
      email: formData.get('email'),
      country: formData.get('country'),
      website: formData.get('website'),
      website1: formData.get('website1'),
      company: formData.get('company'),
      newsletter: formData.get('newsletter'),
    };

    try {
        //https://p4jw5r7mqb.execute-api.us-west-2.amazonaws.com/dev

      await axios.post('https://p4jw5r7mqb.execute-api.us-west-2.amazonaws.com/dev/createLead', data);
      sessionStorage.setItem("exec_summary_submitted", "1");
      navigate('/page-thankyou', { state: { firstName: data.firstName } });
    } catch (error) {
      console.error('Failed to send email:', error);
      alert('Failed to send message. Please try again.');
    }
  };
  return (
    <>
     <Navbar/> 
     <SEO
  title="Contact Pioneer One Global – Start Your India Journey Today"
  description="Let’s talk about your India plans. Book a consultation or drop us a line — we’re here to guide your next chapter in India."
  url="https://www.pioneeroneglobal.com/contact"
  image="https://www.pioneeroneglobal.com/images/og-contact.jpg"
/>
{/* <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${bg})`, backgroundPosition:'center'}}>
        <div className="bg-overlay bg-overlay-white"></div>
        <div className="container">
            <div className="row mt-5 text-center align-items-center">
                <div className="col-sm-6">
                    <div className="text-sm-start">
                        <div className="page-next-level">
                            <h4 className="title">Bridge to Bharath</h4>
                            <p className="text-muted mb-0">Download Executive Summary</p>
                        </div>
                    </div>
                </div>

                <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                    <div className="page-next-level text-sm-end">
                        <ul className="page-next ps-0 mb-0">
                            <li className="list-inline-item"><Link to="/" className="text-uppercase fw-bold text-dark">Home</Link></li>
                            <li className="list-inline-item"><span className="text-uppercase text-primary fw-bold">Bridge</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div> 
    </section> */}

<section className="bg-half-170 bg-light d-table w-100">
      <div className="container">
          <div className="row align-items-center mt-5">
              <div className="col-lg-6 col-md-5">
                  <div className="me-lg-5">
                      <img src={heroImg} className="img-fluid rounded" alt=""/>
                  </div>
              </div>

              <div className="col-lg-6 col-md-7 mt-4 pt-2 mt-sm-0 pt-sm-0">
                  <div className="title-heading mt-4">
                      <h1 className="heading mb-3">Bridge to Bharath Podcast Executive Summary</h1>
                      <p className="para-desc text-muted">In it we unpack how global companies win—or lose—in India’s complex, high-growth market.</p>
                      <p className="text-muted description">The Executive Summary is your companion to our first podcast mini-series. It distills the core insights into a quick, practical roadmap:</p>
<ul className="list-inline mb-0">
                      <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i>The 4 costly mistakes foreign companies keep making</li>
                      <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i>A 3-step playbook to evaluate, enter, and scale in India</li>
                          <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Success stories from Micron, HubSpot, Schibsted, and more</li>
                       </ul>
<p className="text-muted description">Download it now by filling out the form below, then dive deeper with the Bridge to Bharath podcast.</p>

</div>
                                          {/* <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                                                <ul className="list-unstyled text-sm-end social-icon social mb-0">
                                                    {footerBlogSocial.map((item,index)=>{
                                                        return(
                                                              <a
                                                              href={item.link}
                                                              target="_blank"
                                                              rel="noopener noreferrer"
                                                              className="podcast-button"
                                                            >
                                                              <img src={item.image} style={{ height: "36px" ,marginRight: "10px" }}alt="Podcasts" />
                                                              
                                                            </a>)})}
                                                </ul>
                                            </div> */}
              </div>
          </div>
      </div>
    </section>

    <ShapeTwo/>

    <section className="section">


      <div className="container mt-100 mt-60">
          {/* <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Not quite there yet?</h4>
                      <p className="text-muted para-desc mx-auto mb-0">If you have a quick question, idea, or simply want to say hello, feel free to use the contact form below.</p>
                  </div>
              </div>
          </div> */}
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Your companion to the Bridge to Bharath podcast.</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Download the Executive Summary and start building your roadmap to India.</p>
                  </div>
              </div>
          </div>

          <div className="row justify-content-center">
              <div className="col-md-8 mt-4 pt-2">
                  <div className="custom-form">
                      <form ref={form} onSubmit={sendEmail}>
                          <div className="row">
                              <div className="col-md-6">
                                  <div className="mb-3">
                                      <label className="form-label">First Name <span className="text-danger">*</span></label>
                                      <input name="firstName" id="firstName" type="text" className="form-control" placeholder="FirstName :"/>
                                  </div>
                              </div>

                              <div className="col-md-6">
                                  <div className="mb-3">
                                  <label className="form-label">Last Name</label>
                                      <input name="lastName" id="lastName" className="form-control" placeholder="LastName :"/>
                                   </div>
                              </div>

                              <div className="col-12">
                                  <div className="mb-3">
                                        <label className="form-label">Your Email <span className="text-danger">*</span></label>
                                      <input name="email" id="email" type="email" className="form-control" placeholder="Email :"/>
                                 </div>
                              </div>

                              <div className="col-12">
                                  <div className="mb-3">
                                  <label className="form-label">Company <span className="text-danger">*</span></label>
                                      <input name="company" id="company" type="text" className="form-control" placeholder="Company :"/>
                                 </div>
                              </div>

                              <div className="col-12">
                                  <div className="mb-3">
                                  <label className="form-label">Country <span className="text-danger"></span></label>
                                      <input name="country" id="country" type="text" className="form-control" placeholder="Country :"/>
                                 </div>
                              </div>


                              <div className="col-12">
                                  <div className="mb-3">
                                      <label className="form-label">Company Website <span className="text-danger"></span></label>
                                      <input name="website1" id="website1" className="form-control" placeholder="Website :"/>
                                      <input name="website" id="website" hidden={true} className="form-control" placeholder=""/>
                                 </div>
                              </div>
                              <div className="col-12">
  <div className="mb-3 form-check">
    {/* Hidden input ensures a default "no" is sent if the box is unchecked */}
    <input type="hidden" name="newsletter" value="no" />

    <input
      type="checkbox"
      className="form-check-input"
      id="newsletter"
      name="newsletter"
      value="yes"
    />
    <label className="text-primary mb-0" htmlFor="newsletter">
      Sign me up for the Pioneer One Global monthly newsletter
    </label>
  </div>
</div>
                          </div>
                          <div className="row">
                              <div className="col-12">
                                  <div className="d-grid">
                                      <button type="submit" id="submit" name="send" className="btn btn-primary">Get My Free Executive Summary</button>
                                  </div>
                              </div>
                          </div>
                      </form>
                  </div>
              </div>
          </div>
      </div>
    </section>
    <Shape/>
    <Footer/>

      <Modal show={show} onHide={()=>setShow(!show)} size='lg'>
        <Modal.Body>
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d39206.002432144705!2d-95.4973981212445!3d29.709510002925988!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640c16de81f3ca5%3A0xf43e0b60ae539ac9!2sGerald+D.+Hines+Waterwall+Park!5e0!3m2!1sen!2sin!4v1566305861440!5m2!1sen!2sin" title='map' data-type="iframe" className="video-play-icon lightbox h6 text-white w-100" frameBorder="0" ></iframe>
        </Modal.Body>
      </Modal>
    </>
  )
}
